class ProductAccordion extends HTMLElement {
  connectedCallback() {
    if (this.dataset.productAccordionInitialized === 'true') return;

    this.dataset.productAccordionInitialized = 'true';
    this.button = this.querySelector('.product-accordion__button');
    this.panel = this.querySelector('.product-accordion__content');

    if (!this.button || !this.panel) return;

    this.handleHashChange = this.openFromHash.bind(this);
    this.button.addEventListener('click', this.toggle.bind(this));
    this.setOpen(this.button.getAttribute('aria-expanded') === 'true');
    this.openFromHash();
    window.addEventListener('hashchange', this.handleHashChange);
  }

  disconnectedCallback() {
    if (this.handleHashChange) {
      window.removeEventListener('hashchange', this.handleHashChange);
    }
  }

  toggle() {
    const isOpen = this.button.getAttribute('aria-expanded') === 'true';
    this.setOpen(!isOpen);
  }

  setOpen(isOpen) {
    this.button.setAttribute('aria-expanded', String(isOpen));
    this.panel.hidden = !isOpen;
    this.querySelector('.product-accordion__item')?.classList.toggle('is-open', isOpen);
  }

  openFromHash() {
    if (!this.id || window.location.hash !== `#${this.id}`) return;

    this.setOpen(true);
  }
}

if (!customElements.get('product-accordion')) {
  customElements.define('product-accordion', ProductAccordion);
}
